module.exports = __webpack_public_path__ + "media/svg-new/potions-296c9926.svg";